import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorMessageType } from '@/common/types/app';
import Modal from '@/components/Modal';

interface Props {
  errorMessage: ErrorMessageType;
  setErrorMessage: (message: ErrorMessageType) => void;
}

const ModalError: FC<Props> = ({ errorMessage, setErrorMessage }) => {
  const onClose = () => {
    setErrorMessage(null);
    setTimeout(() => document.location.reload());
  };

  return (
    <Modal
      show={!!errorMessage}
      title={<FormattedMessage defaultMessage="Ошибка" />}
      onClose={onClose}
    >
      <p>{errorMessage}</p>
    </Modal>
  );
};

export default ModalError;
